/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';

import { CONFIG_TOKEN } from '@shared/tokens';
import { Config } from '@shared/types';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

@Injectable({
  providedIn: 'root',
})
export class GtagService {
  readonly #config = inject<Config>(CONFIG_TOKEN);

  #loadPromise?: Promise<void>;

  /**
   * This is for future use cases, when we will need to send custom events
   */
  public pushTag(...params: any[]): void {
    if (!this.#loadPromise) {
      this.addGtmToDom();
    }

    if (this.#loadPromise) {
      this.#loadPromise.then(() => {
        window.gtag(...params);
      });
    }
  }

  public addGtmToDom(): void {
    if (this.#loadPromise || !this.#config.gtagMeasurementId) {
      return;
    }

    this.#loadPromise = new Promise((resolve, reject) => {
      const gtmScript = document.createElement('script');
      gtmScript.id = 'GTMscript';
      gtmScript.async = true;
      gtmScript.src = `https://www.googletagmanager.com/gtag/js?id=${this.#config.gtagMeasurementId}`;
      gtmScript.addEventListener('load', () => {
        return resolve();
      });
      gtmScript.addEventListener('error', () => {
        this.#loadPromise = undefined;
        return reject();
      });
      document.head.insertBefore(gtmScript, document.head.firstChild);

      if (!window.dataLayer) {
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
          // eslint-disable-next-line prefer-rest-params
          window.dataLayer.push(arguments);
        };
        window.gtag('js', new Date());
        window.gtag('config', this.#config.gtagMeasurementId);
      }
    });
  }
}
